import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createYardAdmin } from '../../store/yards';
import { useLoadAppData } from '../../hooks/useLoadAppData';

function AddYardPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoading = useLoadAppData();
  const sessionUser = useSelector(state => state.session.user);
  const accounts = useSelector(state =>
    Array.isArray(state.accounts) ? state.accounts : Object.values(state.accounts || {})
  );
  console.log('Accounts data:---------> ', accounts);

  const [formData, setFormData] = useState({
    name: '',
    parking_location: '',
    parking_spots: false,
    account_id: sessionUser?.is_admin ? '' : sessionUser?.account_id
  });

  const [errors, setErrors] = useState([]);

  console.log('Accounts data:', accounts);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const newYard = await dispatch(createYardAdmin({
        ...formData,
        account_id: parseInt(formData.account_id)
      }));
      console.log('New Yard:', newYard);
      // history.push(`/yards/${newYard.id}`);
      history.push(`/`);
    } catch (error) {
      setErrors(error.errors || ['An error occurred while creating the yard']);
    }
  };

  if (isLoading) {
    return <div className="p-5 text-7xl">Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-8xl font-bold mb-5 text-center text-blue-600">Add New Yard</h1>

        {errors.length > 0 && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {errors.map((error, idx) => (
              <p key={idx}>{error}</p>
            ))}
          </div>
        )}

        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6">
          <div className="space-y-6">
            {sessionUser?.is_admin && (
              <div>
                <label className="text-xl font-semibold">Account</label>
                <select
                  name="account_id"
                  value={formData.account_id}
                  onChange={handleChange}
                  className="w-full mt-2 p-3 text-xl rounded-lg border border-gray-300"
                  required
                >
                  <option value="">Select an Account</option>
                  {accounts && accounts.length > 0 && accounts.map(account => (
                    <option key={account.id} value={account.id}>
                      {account.account_name}
                    </option>
                  ))}
                </select>
                <div className="text-sm text-gray-500 mt-1">
                  {accounts.length} accounts available
                </div>
              </div>
            )}

            <div>
              <label className="text-xl font-semibold">Yard Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full mt-2 p-3 text-xl rounded-lg border border-gray-300"
                required
              />
            </div>

            <div>
              <label className="text-xl font-semibold">Parking Location</label>
              <input
                type="text"
                name="parking_location"
                value={formData.parking_location}
                onChange={handleChange}
                className="w-full mt-2 p-3 text-xl rounded-lg border border-gray-300"
                required
              />
            </div>

            <div>
              <label className="flex items-center gap-3 text-xl font-semibold">
                <input
                  type="checkbox"
                  name="parking_spots"
                  checked={formData.parking_spots}
                  onChange={handleChange}
                  className="w-6 h-6"
                />
                Parking Spots Available
              </label>
            </div>

            <div className="flex justify-end gap-4">
              <button
                type="button"
                onClick={() => history.push('/')}
                className="px-6 py-3 text-xl text-gray-700 bg-gray-200 rounded-lg transition-all duration-200
                  hover:bg-gray-300 hover:shadow-md hover:scale-[1.02]"
              >
                Cancel
              </button>
              <button id = 'add-yard-button'
                type="submit"
                className="px-6 py-3 text-xl bg-blue-600 text-white rounded-lg transition-all duration-200
                  hover:bg-blue-700 hover:shadow-md hover:scale-[1.02]"
              >
                Add Yard
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddYardPage;
